import React from "react";
import { isOrderModified, hasUnseenModification, normalizeRevision } from "@/lib/orderRevision";

/**
 * Small pill that surfaces order-level revisions. Amber (=needs review) when
 * the server-side ack (last_seen_revision_number) is behind revision_number,
 * gray once acknowledged. Renders nothing for un-modified orders.
 */
export default function RevisionBadge({ order, size = "sm" }) {
  if (!isOrderModified(order)) return null;
  const unseen = hasUnseenModification(order);
  const rev = normalizeRevision(order.revision_number);

  const base = size === "md" ? "px-2.5 py-1 text-[11px]" : "px-2 py-0.5 text-[10px]";
  const style = unseen
    ? "border-amber-400 bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-700"
    : "border-zinc-300 bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300 dark:border-zinc-700";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border font-bold uppercase tracking-[0.15em] whitespace-nowrap ${base} ${style}`}
      data-testid={`revision-badge-${unseen ? "unseen" : "seen"}`}
      title={unseen ? "This order was modified upstream — not yet reviewed" : `Revision ${rev} · already reviewed`}
    >
      {unseen ? "★ " : ""}REV {rev}
    </span>
  );
}
